/**
 * Obtiene el array de conceptos desde cualquier forma habitual del BFF / API remoto.
 */
export function extractConceptosNovedadesRawList(raw) {
  let data = raw;
  if (data == null) return [];
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return [];
    }
  }
  if (Array.isArray(data)) return data;

  const keyCandidates = [
    'listaConceptoNovedades', 'ListaConceptoNovedades',
    'tiposNovedades', 'TiposNovedades',
    'conceptos', 'Conceptos',
    'tiposConceptos', 'TiposConceptos',
    'listaConceptos', 'ListaConceptos',
    'elementos', 'Elementos',
    'content', 'Content',
    'items', 'Items',
    'result', 'Result',
    'resultados', 'Resultados',
    'datos', 'Datos',
    'value', 'Value'
  ];

  const pickFromObject = (obj) => {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return [];
    for (const k of keyCandidates) {
      const v = obj[k];
      if (Array.isArray(v)) return v;
    }
    return [];
  };

  let list = pickFromObject(data);
  if (list.length) return list;

  const nestedRoots = ['data', 'Data', 'result', 'Result', 'payload', 'Payload', 'response', 'Response'];
  for (const nr of nestedRoots) {
    const inner = data[nr];
    if (inner == null || typeof inner !== 'object') continue;
    list = pickFromObject(inner);
    if (list.length) return list;
    if (Array.isArray(inner)) return inner;
  }

  if (data.data != null && typeof data.data === 'object') {
    list = pickFromObject(data.data);
    if (list.length) return list;
    if (Array.isArray(data.data)) return data.data;
  }

  if (data.result != null && typeof data.result === 'object' && !Array.isArray(data.result)) {
    list = pickFromObject(data.result);
    if (list.length) return list;
  }

  const looksConceptoItem = (x) => x && typeof x === 'object' && (
    'idTipoNovedad' in x || 'IdTipoNovedad' in x
    || 'idConcepto' in x || 'IdConcepto' in x
    || 'concepto' in x || 'Concepto' in x
    || 'descripcionSubTipoNovedad' in x || 'DescripcionSubTipoNovedad' in x
    || 'descripcionSubTipo' in x || 'DescripcionSubTipo' in x
    || 'idSubTipo' in x || 'IdSubTipo' in x
  );

  const firstMatchingArray = (obj) => {
    if (!obj || typeof obj !== 'object') return [];
    for (const v of Object.values(obj)) {
      if (!Array.isArray(v) || v.length === 0) continue;
      if (looksConceptoItem(v[0])) return v;
    }
    for (const v of Object.values(obj)) {
      if (Array.isArray(v) && v.length > 0 && looksConceptoItem(v[0])) return v;
    }
    return [];
  };

  list = firstMatchingArray(data);
  if (list.length) return list;
  if (data.data && typeof data.data === 'object') {
    list = firstMatchingArray(data.data);
    if (list.length) return list;
  }

  return [];
}
